/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PaymentProcessStatusPaymentsInnerStatusEnum = {
    Unpaid: 'unpaid',
    Processing: 'processing',
    Paid: 'paid',
    Failed: 'failed',
    Finalizing: 'finalizing',
    Finalized: 'finalized',
    Canceling: 'canceling',
    Cancelled: 'cancelled'
};
/**
 * Check if a given object implements the PaymentProcessStatusPaymentsInner interface.
 */
export function instanceOfPaymentProcessStatusPaymentsInner(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function PaymentProcessStatusPaymentsInnerFromJSON(json) {
    return PaymentProcessStatusPaymentsInnerFromJSONTyped(json, false);
}
export function PaymentProcessStatusPaymentsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
    };
}
export function PaymentProcessStatusPaymentsInnerToJSON(json) {
    return PaymentProcessStatusPaymentsInnerToJSONTyped(json, false);
}
export function PaymentProcessStatusPaymentsInnerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
    };
}
